import { useEffect, useState } from 'react';

import { useWebSocket } from '../../shared/hooks/useWebSocket';

const COORDINATES_TOPIC = 'coordinates';

type Message = {
  data: { lat: number; lng: number }[];
};

export const useLiveDriverUpdates = (isInProgress, rideId) => {
  const [lastCoordinatesDateTime, setLastCoordinatesDateTime] = useState<Date | null>(null);

  const { lastJsonMessage: driverCoordinatesChanged } = useWebSocket<Message>(
    {
      topic: COORDINATES_TOPIC,
      trip_id: rideId,
    },
    { reconnectAttempts: 10 },
    isInProgress
  );

  useEffect(() => {
    if (driverCoordinatesChanged?.data) {
      setLastCoordinatesDateTime(new Date());
    }
  }, [driverCoordinatesChanged?.data]);

  return {
    driverCoordinatesChanged,
    lastCoordinatesDateTime,
  };
};
